export const gameAttributesSyncedToUi = [
	"alwaysShowCountry",
	"budget",
	"challengeNoRatings",
	"challengeNoTrades",
	"currencyFormat",
	"draftType",
	"fantasyPoints",
	"gameOver",
	"gender",
	"godMode",
	"hideDisabledTeams",
	"homeCourtAdvantage",
	"lid",
	"luxuryPayroll",
	"luxuryTax",
	"maxContract",
	"minContract",
	"minPayroll",
	"neutralSite",
	"numGames",
	"numPeriods",
	"numWatchColors",
	"phase",
	"quarterLength",
	"salaryCap",
	"salaryCapType",
	"season",
	"spectator",
	"startingSeason",
	"teamInfoCache",
	"userTid",
	"userTids",
] as const;
